








































import MaturityBanners from '../subComponents/MaturityBanner/MaturityBanners.vue';
import LoadingBox from '../LoadingBox/LoadingBox.vue';
import {
  getInvestment,
  getTransactions,
  IPolicyData,
  getBannerFromPolicy,
  IMaturityBanner,
  ITransactionsData,
} from '../../api';
import DetailsTable from './DetailsTable.vue';
import Accordion from '../subComponents/Accordion/Accordion.vue';
import { apiErrorHelper } from '../../api/apiErrorHelper';
import TaxDetails from './TaxDetails.vue';
import Transactions from './Transactions.vue';
import BankDetails from './BankDetails.vue';
import Distribution from './Distribution.vue';
import AdviserDetails from './AdviserDetails.vue';
import BeneficiaryDetails from './BeneficiaryDetails.vue';
import {
  PRODUCT_CARE_PLUS,
  PRODUCT_UNIT_TRUST,
  PRODUCT_ANNUITY_FIXED_TERM,
  PRODUCT_ANNUITY_LIFETIME,
  PRODUCT_ANNUITY_LIQUID_LIFETIME,
  PRODUCT_ALLOCATED_PENSION_CASH,
  PRODUCT_ALLOCATED_PENSION_FIXED,
  PRODUCT_SUPERANNUATION_FUND_CASH,
  PRODUCT_SUPERANNUATION_FUND_FIXED,
} from '../../utils/fieldMappers/constants';

export default {
  name: 'InvestmentDetails',
  components: { Accordion, DetailsTable, MaturityBanners, LoadingBox, TaxDetails, Transactions },
  data() {
    return {
      investment: null,
      transactions: null,
      loading: true,
      apiBanners: null, // list of Banner retrieve from API - maybe on mounted...
    };
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  async mounted() {
    this.accountNumber = this.$route.query.id;
    this.investmentOptionId = this.$route.query.option;
    await this.loadInvestment();
    await this.loadTransactions();
    this.loading = false;
  },
  computed: {
    contentBanners() {
      // This will get all Content for the possible Banners.
      if (this.fields) {
        return this.fields.Banners;
      }
      return null;
    },
    accordions() {
      return {
        transactions: {
          title: 'Transactions',
          content: Transactions,
          data: { transactions: this.transactions, investment: this.investment },
          open: 0,
          icon: 'mdi-currency-usd',
          sortOrder: 7,
        },
        bankAccountDetails: {
          title: 'Bank account details',
          content: BankDetails,
          data: { investment: this.investment },
          icon: 'mdi-bank-outline',
          sortOrder: 2,
        },
        distribution: {
          title: 'Distributions',
          content: Distribution,
          data: { investment: this.investment },
          icon: 'mdi-format-list-bulleted',
          sortOrder: 4,
        },
        financialAdviser: {
          title: 'Financial adviser',
          content: AdviserDetails,
          data: { investment: this.investment },
          icon: 'mdi-format-list-bulleted',
          sortOrder: 6,
        },
        taxDetails: {
          title: 'Tax details',
          content: TaxDetails,
          data: this.investment,
          footnotes: ['* SAPTO: Seniors And Pensioners Tax Offset'],
          icon: 'mdi-format-list-bulleted',
          sortOrder: 1,
        },
        beneficiaryDetails: {
          title: 'Beneficiary details',
          data: { investment: this.investment },
          content: BeneficiaryDetails,
          icon: 'mdi-account-group',
          sortOrder: 5,
        },
      };
    },
    displayAccordions() {
      const { accountProductType, accountType } = this.investment;
      let accordions = [];
      if (accountProductType === PRODUCT_CARE_PLUS) {
        return [];
      }
      accordions.push(this.accordions.transactions);
      if (this.productsShowingBankDetails(accountProductType)) {
        accordions.push(this.accordions.bankAccountDetails);
      } else {
        if (
          accountProductType !== PRODUCT_SUPERANNUATION_FUND_CASH &&
          accountProductType !== PRODUCT_SUPERANNUATION_FUND_FIXED
        ) {
          accordions.push(this.accordions.distribution);
        }
      }
      if (accountProductType === PRODUCT_UNIT_TRUST) {
        accordions.push(this.accordions.financialAdviser);
      } else {
        accordions.push(this.accordions.taxDetails, this.accordions.financialAdviser);
        if (this.accountTypesShowingBeneficiaryDetails(accountType)) {
          accordions.push(this.accordions.beneficiaryDetails);
        }
      }
      return accordions.sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
      });
    },
  },
  methods: {
    hasBanner() {
      if (this.apiBanners == null || typeof this.apiBanners == 'undefined') return false;
      if (this.apiBanners.length > 0) return true;
      return false;
    },
    accordionVisible(accordion) {
      return true;
    },
    productsShowingBankDetails(accountProductType) {
      if (
        accountProductType !== PRODUCT_UNIT_TRUST &&
        accountProductType !== PRODUCT_SUPERANNUATION_FUND_CASH &&
        accountProductType !== PRODUCT_SUPERANNUATION_FUND_FIXED
      ) {
        return true;
      }
      return false;
    },
    accountTypesShowingBeneficiaryDetails(accountType) {
      if (
        this.splitAccountType(accountType) !== 'Company' &&
        this.splitAccountType(accountType) !== 'Trust' &&
        this.splitAccountType(accountType) !== 'Superannuation'
      ) {
        return true;
      }
      return false;
    },
    splitAccountType(accountType) {
      return accountType.split('/')[0];
    },
    async loadInvestment() {
      try {
        const investment: IPolicyData = await getInvestment(
          this.accountNumber,
          this.investmentOptionId
        );
        if (investment.data) {
          this.investment = investment.data;
          // get the banner
          let banner = getBannerFromPolicy(investment.data);
          if (banner != null) {
            this.apiBanners = new Array<IMaturityBanner>();
            this.apiBanners.push(banner);
          }
        }
      } catch (error) {
        this.loading = false;
        apiErrorHelper(this.$router, error);
      }
    },
    async loadTransactions(pageNumber = 1) {
      try {
        const transactions: ITransactionsData = await getTransactions(
          this.accountNumber,
          this.investmentOptionId,
          pageNumber
        );
        if (transactions.data) {
          this.transactions = transactions.data;
        }
      } catch (error) {
        this.loading = false;
        apiErrorHelper(this.$router, error);
      }
    },
  },
};
